export const VIEW_TYPES = {
  OVERVIEW: "OVERVIEW",
  DETAILS: "DETAILS",
};
